import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, Field } from 'redux-form'
import { Flex, Box } from 'grid-styled'
import Button from '../../elements/Button'
import Radio from '../../elements/Radio'
import rem from '../../../styles/tools/rem'
import { labels } from './data.json'

import { Buttons, Title, Subtitle, FormField } from './styles'
import CreditPaymentForm from './credit'
import DebitPaymentForm from './debit'

class PaymentForm extends Component {
  componentDidMount() {
    const { paymentType } = this.props
    if (paymentType === 'DEBITO_EM_CONTA') {
      this.props.initialize({
        paymentMethod: 'CUENTA'
      })
    } else if (paymentType === 'CARTAO_DE_CREDITO') {
      this.props.initialize({ paymentMethod: 'CAJA' })
    } else {
      this.props.initialize({ paymentMethod: 'DISPOSICION' })
    }
  }

  render() {
    const {
      handleSubmit,
      onSubmit,
      paymentType,
      paymentInfo,
      onSucessUpdate,
      creditCardUpdated,
      reset,
      dueDates,
      paymentTypesOptions,
      formValues,
      ...props
    } = this.props

    return (
      <div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormField>
            <Title>Selecione a forma de pagamento</Title>
            <div>
              <Flex direction={['column', 'row']}>
                {paymentTypesOptions.formas.map(paymentType => (
                  <Box key={paymentType.forma} mr={20} mb={[39, 28]}>
                    <Field
                      component={Radio}
                      label={paymentType.descricao}
                      name="paymentMethod"
                      type="radio"
                      value={paymentType.forma}
                    />
                  </Box>
                ))}
              </Flex>
            </div>
            <Flex direction="column">
              {formValues &&
                formValues.paymentMethod === 'CUENTA' && (
                  <div>
                    <Subtitle>Preencha os dados do seu banco</Subtitle>
                    <DebitPaymentForm />
                  </div>
                )}
              {formValues &&
                formValues.paymentMethod === 'CAJA' && (
                  <div>
                    <Subtitle>Preencha os dados do seu cartão</Subtitle>
                    <CreditPaymentForm formValues={formValues} />
                  </div>
                )}
            </Flex>
          </FormField>
          <Buttons>
            <Box>
              <Button
                onClick={props.handleBackClick}
                text={labels.buttons.back}
                buttonType="white"
                width={rem('220px')}
              />
            </Box>
            <Box mt={[15, 0]} ml={[12, 60]}>
              <Button
                text={props.submitting ? labels.buttons.saving : labels.buttons.save}
                type={formValues && 'submit'}
                width={rem('220px')}
                disabled={!props.dirty || props.invalid || props.submitting}
              />
            </Box>
          </Buttons>
        </form>
      </div>
    )
  }
}

const Container = connect(state => ({
  formValues: getFormValues('PaymentForm')(state)
}))

const Form = reduxForm({
  form: 'PaymentForm'
})(Container(PaymentForm))

export default Form



// WEBPACK FOOTER //
// ./src/app/modules/PaymentForm/index.js